"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRefundTotal = calculateRefundTotal;
exports.calculateLineTotal = calculateLineTotal;
exports.initializeRefundItem = initializeRefundItem;
exports.initializeRefundItemByPrice = initializeRefundItemByPrice;
exports.computeRefundableItems = computeRefundableItems;
exports.buildRefundItemsRequest = buildRefundItemsRequest;
function calculateRefundTotal(editableItems) {
    return editableItems.reduce((total, item) => {
        const returnedAmount = item.returnedAmount ?? 0;
        const returnedPrice = item.returnedPrice ?? 0;
        return total + returnedAmount * returnedPrice;
    }, 0);
}
function calculateLineTotal(returnedAmount, returnedPrice) {
    return returnedAmount * returnedPrice;
}
function initializeRefundItem(item) {
    const effectivePrice = item.amount > 0 ? item.payAmount / item.amount : item.payAmount;
    return {
        ...item,
        amountInput: '0',
        priceInput: String(effectivePrice),
        returnedAmount: 0,
        returnedPrice: effectivePrice,
        returnedTotal: 0,
    };
}
function initializeRefundItemByPrice(item) {
    const effectiveAmount = Math.max(1, item.amount);
    const effectivePrice = item.payAmount / effectiveAmount;
    return {
        ...item,
        amount: effectiveAmount,
        price: effectivePrice,
        amountInput: String(effectiveAmount),
        priceInput: '0',
        returnedAmount: effectiveAmount,
        returnedPrice: 0,
        returnedTotal: 0,
    };
}
/**
 * Derives the list of refundable items from the full orderItems array.
 * Filters out return items, aggregates already-refunded quantities AND values
 * per aisleCode, and adjusts `amount` and `payAmount` to reflect only the
 * remaining refundable portion.
 *
 * Items are excluded when remaining refundable value reaches zero.
 *
 * This is a pure function — it never mutates its input.
 */
function computeRefundableItems(orderItems) {
    const purchaseItems = orderItems.filter((item) => item.isReturn !== true);
    const returnItems = orderItems.filter((item) => item.isReturn === true);
    const refundedByAisle = new Map();
    for (const ret of returnItems) {
        const prev = refundedByAisle.get(ret.aisleCode) ?? {
            quantity: 0,
            value: 0,
        };
        refundedByAisle.set(ret.aisleCode, {
            quantity: prev.quantity + Math.abs(ret.amount),
            value: prev.value + Math.abs(ret.payAmount),
        });
    }
    return purchaseItems
        .map((item) => {
        const refunded = refundedByAisle.get(item.aisleCode) ?? {
            quantity: 0,
            value: 0,
        };
        const remainingValue = Math.max(0, item.payAmount - refunded.value);
        if (remainingValue <= 0)
            return null;
        const unitPrice = item.amount > 0 ? item.payAmount / item.amount : item.payAmount;
        const refundedQtyByValue = unitPrice > 0 ? Math.floor(refunded.value / unitPrice) : 0;
        const effectiveRefundedQty = Math.min(refunded.quantity, refundedQtyByValue);
        const remainingAmount = Math.max(0, item.amount - effectiveRefundedQty);
        return {
            ...item,
            amount: remainingAmount,
            payAmount: remainingValue,
        };
    })
        .filter((item) => item !== null);
}
function buildRefundItemsRequest(editableItems, refundType) {
    return editableItems
        .filter((item) => (item.returnedTotal ?? 0) > 0)
        .map((item) => ({
        aisleCode: item.aisleCode,
        quantity: refundType === 'quantity' ? (item.returnedAmount ?? 0) : null,
        refundAmount: refundType === 'price' ? (item.returnedTotal ?? 0) : null,
    }));
}
